import { object, string, null as zNull, type infer as zInfer } from "zod/v4";

export const deleteParentEasypostIntegration = {
  name: "deleteParentEasypostIntegration" as const,
  input: object({ integrationId: string() }),
  output: zNull(),
};

export type DeleteParentEasypostIntegrationInput = zInfer<
  typeof deleteParentEasypostIntegration.input
>;
